module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_8011.486548eb.png";